module.exports = __webpack_public_path__ + "static/media/user_input.7a762ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LivestockIdxTool/user_input.png
// module id = 1788
// module chunks = 0